import { UnconfiguredRules } from "system/types/interfaces";

export const defaultNotConfiguredRules: UnconfiguredRules[] = [
  {
    name: "/continue-before-logon",
    description:
      "Schedules the requested packages to rerun after the next reboot, before a user can log on if a task was unable to complete while an application was running, or if a package needs to continue running after a reboot.",
    type: "enum",
    regex: "(silent|unattended)",
    defaultValue: "silent",
  },
  {
    name: "/start-before-logon",
    description:
      "Packages will not run during this session. Instead, all requested packages will be scheduled to run after the next reboot, before a user can log on. Will exit with code 3017 (reboot required to continue).",
    type: "enum",
    regex: "(silent|unattended)",
    defaultValue: "silent",
  },
  {
    name: "/auto-reboot",
    description:
      "Automatically reboots the computer when the task sequence is complete if any package requires a reboot to complete. May only be used in unattended mode or silent mode.",
    type: "bool",
    regex: "",
    defaultValue: "false",
  },
  {
    name: "/max-run-time",
    description:
      "Limits the amount of time, in minutes, the task sequence is allowed to run. When the max run time is reached, this process will end, and will allow the currently running package to continue.",
    type: "long",
    regex: "\\d+",
    defaultValue: "0",
  },
  {
    name: "default-max-package-run-time",
    description:
      "Limits the amount of time, in minutes, any package is allowed to run, unless overridden by a Package Config max-run-time value.",
    type: "long",
    regex: "\\d+",
    defaultValue: "0",
  },
  {
    name: "/window-state",
    description: "Sets the initial window state.",
    type: "enum",
    regex: "(normal|maximized|minimized)",
    defaultValue: "normal",
  },
  {
    name: "/always-on-top",
    description:
      "Sets the window to appear above all other windows, except windows which have also been set to appear on top. Ignored while in silent mode.",
    type: "bool",
    regex: "",
    defaultValue: "false",
  },
  {
    name: "/remain-open",
    description: "Prevents the application from closing after all tasks have completed. May only be used in unattended mode.",
    type: "bool",
    regex: "",
    defaultValue: "false",
  },
  {
    name: "/keep-display-on",
    description: "Prevents the display from turning off while processing the queue. May only be used in unattended mode.",
    type: "bool",
    regex: "",
    defaultValue: "false",
  },
];